export class PrescriptionLine {
  drugType: string;
  drug: string;
  dose: number | null;
  unitId: number | null;
  duration: number | null;
  durationType: string;
  route: number | null;
  indication: number | null;
  name: string;
  summary: string;
  indicationName: string;
  frecuency: number | null;
  idFrecuencyType: number | null;
  frecuencyType: string;
  obs: string;
  unitIdName: string;
  durationName: string;
  routeName: string;
  hide: boolean = false;

  showNoAnalysisLegend: boolean = false;

  constructor(prescriptionLine?: Partial<PrescriptionLine>) {
    this.drugType = prescriptionLine?.drugType ?? '';
    this.drug = prescriptionLine?.drug ?? '';
    this.dose = prescriptionLine?.dose ?? null;
    this.unitId = prescriptionLine?.unitId ?? null;
    this.duration = prescriptionLine?.duration ?? null;
    this.durationType = prescriptionLine?.durationType ?? '';
    this.route = prescriptionLine?.route ?? null;
    this.indication = prescriptionLine?.indication ?? null;

    this.name = prescriptionLine?.name ?? '';
    this.summary = prescriptionLine?.summary ?? '';
    this.indicationName = prescriptionLine?.indicationName ?? '';
    this.frecuency = prescriptionLine?.frecuency ?? null;
    this.idFrecuencyType = prescriptionLine?.idFrecuencyType ?? null;
    this.frecuencyType = prescriptionLine?.frecuencyType ?? '';
    this.obs = prescriptionLine?.obs ?? '';

    this.unitIdName = prescriptionLine?.unitIdName ?? '';
    this.durationName = prescriptionLine?.durationName ?? '';
    this.routeName = prescriptionLine?.routeName ?? '';
    this.hide = prescriptionLine?.hide ?? false;

    this.showNoAnalysisLegend = prescriptionLine?.showNoAnalysisLegend ?? false;
  }
}
